<template functional>
	<div class="page" :class="{ 'has-tabs': props.tabs, 'has-title': (props.title !== null) }">
		<header class="page-title d-flex" :class="{ 'sidebar-collapsed': props.sidebarCollapsed }" v-if="props.title !== null">
			<div class="mr-2 d-flex align-items-center">
				<div class="mr-2">
					<slot name="badge"></slot>
				</div>
				<div class="text-nowrap">
					<span class="page-title-icon" v-if="props.icon !== null">
						<font-awesome-icon :icon="props.icon" />
					</span>
					<slot name="headerTitle">
						<span>{{ props.title }}</span>
					</slot>
				</div>
			</div>
			<slot name="itemDetail"></slot>
		</header>

		<slot name="fullwidth"></slot>

		<div class="page-content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			default: null
		},
		icon: {
			default: null
		},
		tabs: Boolean,
		sidebarCollapsed: Boolean
	}
};
</script>

<style lang="scss">
@import '../../_variables';

.page {
	font-size: 14px;

	&.has-title {
		margin-top: $section-topbar-height;
	}

	&.has-tabs {
		margin-top: $page-tabs-height;

		&.has-title {
			margin-top: $section-topbar-height + $page-tabs-height;
		}
	}

	.page-title {
		position: fixed;
		top: $app-topbar-height;
		left: $app-sidebar-width + $section-sidebar-width;
		right: 0;
		padding: 0 20px;
		line-height: $section-topbar-height;
		background-color: $section-topbar-bg;
		color: $section-topbar-color;
		height: $section-topbar-height;
		font-size: 16px;
		z-index: 999;

		&.sidebar-collapsed {
			left: $app-sidebar-collapsed-width + $section-sidebar-width;
		}

		.page-title-icon {
			display: inline-block;
			margin-right: 5px;
		}
	}

	.page-content {
		padding: 20px;
	}

	h1 {
		font-size: 24px;
		color: $page-color;
		font-weight: $font-semibold;
		margin-bottom: 15px;
	}
}
</style>
